import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Modal } from 'semantic-ui-react';

// Global Types
import { AppState } from 'services/types';

// Actions
// @ts-ignore
import { updateQueryString } from 'services/router/actions';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
import {
    makeSelectQueryStringBooleanValue,
    makeSelectQueryStringNumberValue
    // @ts-ignore
} from 'workspaces/react-router-selectors';

// Global Components
import ErrorAlert from 'components/ErrorAlert';
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
import RoleGate from 'components/RoleGate';
import { ADMIN } from 'components/RoleGate/constants';
// @ts-ignore
import WorkTypeName from 'components/WorkTypeName';

// Components
// @ts-ignore
import WorkTypeDeleteForm from './components/WorkTypeDeleteForm';

interface ConnectedProps {
    isOpen: boolean;
    id?: number;
}

interface DispatchProps {
    updateQueryString: Function;
}

type Props = ConnectedProps & DispatchProps;

export class WorkTypeDeleteModal extends React.PureComponent<Props> {
    handleClose = (): void => {
        this.props.updateQueryString({
            workTypeDeleteModal: undefined,
            selectedWorkType: undefined
        });
    };

    render(): React.ReactElement | null {
        const { isOpen, id } = this.props;

        if (!id) {
            return null;
        }

        return (
            <RoleGate requiredRoles={[ADMIN]}>
                <Modal
                    size="tiny"
                    open={isOpen}
                    onClose={this.handleClose}
                    centered={false}
                    closeIcon
                >
                    <ErrorBoundary
                        namespace="WorkTypeDeleteModal"
                        FallbackComponent={<ErrorBoundaryAlert />}
                    >
                        <Modal.Header>
                            {'Delete '}
                            <WorkTypeName workTypeId={id} />
                        </Modal.Header>
                        <Modal.Content>
                            <p>Are you sure you want to delete this task ?</p>
                            <ErrorAlert namespace="WORK_TYPE_DELETE" />
                            <WorkTypeDeleteForm
                                workTypeId={id}
                                onClose={this.handleClose}
                            />
                        </Modal.Content>
                    </ErrorBoundary>
                </Modal>
            </RoleGate>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    isOpen: makeSelectQueryStringBooleanValue('workTypeDeleteModal'),
    id: makeSelectQueryStringNumberValue('selectedWorkType')
});

export default connect(
    mapStateToProps,
    { updateQueryString }
)(WorkTypeDeleteModal);
